import { ActionTree } from "vuex";
import { baseApiLogs } from "@/config/http-logs";
import { IRootState } from "@/store";
import { IDocumentHistoryState } from "@/store/modules/documentHistory/state";
import { DocumentHistoryMutations } from "@/store/modules/documentHistory/mutations";

export enum DocumentHistoryActions {
  FETCH_DATA_PROVIDER = "FETCH_DATA_PROVIDER_DOCUMENT_HISTORY",
}

export const actions: ActionTree<IDocumentHistoryState, IRootState> = {
  async [DocumentHistoryActions.FETCH_DATA_PROVIDER]({ commit }, params) {
    try {
      const result = await baseApiLogs.get(
        "/api/logs/document-logs/get-document-logs",
        {
          params: params,
        }
      );
      commit(DocumentHistoryMutations.SET_LAZY_DATA, result.data.data);
    } catch (error) {
      console.log("fetch documentConstructor data provider error: ", error);
    }
  },
};
